import styled from "styled-components";
function getTagColor(tagType, color, theme) {
    if (tagType === "simple") {
        switch (color) {
            case "default":
                return `background: rgba(${theme.colors.transparentBlack},0.1);
                border: 0.0625rem solid rgba(${theme.colors.transparentBlack},0.26);
                color:${theme.colors.black}`;
            case "success":
                return `background: rgba(${theme.colors.transparentSuccess},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentSuccess},0.46);
        color:${theme.colors.success}`;
            case "warning":
                return `background:  rgba(${theme.colors.transparentWarning},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentWarning},0.46);
        color:${theme.colors.error}`;
            case "error":
                return `background:  rgba(${theme.colors.transparentError},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentError},0.46);
        color:${theme.colors.error}`;
            case "info":
                return `background:  rgba(${theme.colors.transparentPrimaryLight},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentPrimaryLight},0.46);
        color:${theme.colors.primaryDark}`;
            default:
                return `background: rgba(${theme.colors.transparentBlack},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentBlack},0.26);
        color:${theme.colors.black}`;
        }
    }
    if (tagType === "highlight") {
        switch (color) {
            case "standard":
                return `background: ${theme.colors.primaryDark};
        border: 0.0625rem solid ${theme.colors.primaryDark};
        color:${theme.colors.white}`;
            case "disruptive":
                return `background: ${theme.colors.warning};
          border: 0.0625rem solid ${theme.colors.warning};
          color:${theme.colors.white}`;
            default:
                return `background: ${theme.colors.primaryDark};
        border: 0.0625rem solid ${theme.colors.primaryDark};
        color:${theme.colors.white}`;
        }
    }
    if (tagType === "removable") {
        switch (color) {
            case "standard":
                return `background: rgba(${theme.colors.transparentBlack},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentBlack},0.26);
        color:${theme.colors.black}`;
            case "highlight":
                return `background: rgba(${theme.colors.transparentPrimaryLight},0.1);
          border: 0.0625rem solid rgba(${theme.colors.transparentPrimaryLight},0.46);
          color:${theme.colors.primaryDark}`;
            default:
                return `background: rgba(${theme.colors.transparentBlack},0.1);
        border: 0.0625rem solid rgba(${theme.colors.transparentBlack},0.26);
        color:${theme.colors.black}`;
        }
    }
    return `background: rgba(${theme.colors.transparentBlack},0.1);
  border: 0.0625rem solid rgba(${theme.colors.transparentBlack},0.26);
  color:${theme.colors.black}`;
}
export const StyledTag = styled.div `
  position: ${({ position }) => position || "unset"};
  left: ${({ left }) => !!left && left};
  right: ${({ right }) => !!right && right};
  top: ${({ top }) => !!top && top};
  bottom: ${({ bottom }) => !!bottom && bottom};
  display: flex;
  align-items: center;
  justify-content: strech;
  width: fit-content;
  height: ${({ tagType }) => (tagType === "highlight" ? "0.875rem" : "1rem")};
  padding: ${({ padding }) => padding};
  ${({ tagType, color, theme }) => getTagColor(tagType, color, theme)};
  ${({ tagType }) => tagType === "removable"
    ? `
    &:hover{cursor: pointer}
    >label{cursor: pointer}
    `
    : ""};
  &:focus-visible {
    border: 1px solid ${({ theme }) => theme.colors.primaryLight};
    outline: 1px solid ${({ theme }) => theme.colors.primaryLight};
  }
`;
export const StyledIconWrapper = styled.div `
  ${({ isOnRight }) => isOnRight ? `padding-left:0.5rem;cursor:pointer` : "padding-right:0.5rem"}
`;
